import { geoData } from 'client/javascript/geo';
import { logError, logWarning } from 'client/javascript/util/logger';
import { removeAllDomNodes } from 'client/javascript/util/dom_utils';
import {
  isUserCountryInWhitelistedCountriesList,
  isGeoConfiguredModule,
  showModule,
  GEO_MODULE_SELECTOR
} from 'client/javascript/util/geolocation_based_module_rendering/helpers';

export const renderSingleUniqueModule = async (config = {}, errorLabel) => {
  try {
    const { countryCode } = await geoData;
    const { selector = '', context = document } = config;
    const geoConfigured = [];
    const nonGeoConfigured = [];

    const moduleDomNodes = context.querySelectorAll(`${selector}${GEO_MODULE_SELECTOR}`);

    if (!moduleDomNodes.length) {
      return;
    }

    moduleDomNodes.forEach((moduleDomNode) => {
      const { conditionsToShow } = moduleDomNode.dataset;

      if (isGeoConfiguredModule(conditionsToShow)) {
        if (isUserCountryInWhitelistedCountriesList(countryCode, conditionsToShow)) {
          geoConfigured.push(moduleDomNode);
        } else {
          moduleDomNode.remove();
        }
      } else {
        // All nonGeoConfigured modules are stored without any checks because
        // we have an additional check for rendering of the module below
        // only if there is no geoConfigured module.
        nonGeoConfigured.push(moduleDomNode);
      }
    });

    const singleUniqueGeoConfiguredModuleExists = geoConfigured.length === 1;
    const singleUniqueNonGeoConfiguredModuleExists = nonGeoConfigured.length === 1 && !geoConfigured.length;

    if (singleUniqueGeoConfiguredModuleExists) {
      // Allows only one geoConfigured module for rendering if it exists
      // And remove needless nonGeoConfigured modules from a page
      showModule(geoConfigured[0]);
      removeAllDomNodes(nonGeoConfigured);
    } else if (singleUniqueNonGeoConfiguredModuleExists) {
      // Allows only one nonGeoConfigured module for rendering if it exists
      // and there are no geoConfigured modules because more than 1 geoConfigured module also is unexpected result.
      showModule(nonGeoConfigured[0]);
    } else if ([...geoConfigured, ...nonGeoConfigured].length) {
      // If we reached this statement that means we have more than one module of the same type which is considered to be a configuration error.
      // In that case none of the modules will be rendered.
      removeAllDomNodes([...geoConfigured, ...nonGeoConfigured]);
      logWarning(
        `[Geolocation Based Rendering] renderSingleUniqueModule failed: invalid configuration for ${countryCode} country, geoConfigured: ${geoConfigured.length}, nonGeoConfigured: ${nonGeoConfigured.length}`
      );
    }
  } catch (error) {
    // `errorLabel` is optional, its value have to be a name of a geobased module for which the function is used
    // and it uses to sort out by an error message in the Rollbar
    const msgDetails = errorLabel ? ` in ${errorLabel}` : '';
    logError(`[Geolocation Based Rendering] renderSingleUniqueModule failed${msgDetails}: ${error.message}`, error);
  }
};
